import axios from "axios";
import { API_URL_PUBLIC } from "const/constants";

const PUBLIC_BASE = `${API_URL_PUBLIC}/public/referral-onboarding`;

/** Wizard document slot key → backend ReferralPartnerDocumentKind. */
export const SLOT_KINDS = {
  photoId: "PHOTO_ID",
  passport: "PASSPORT",
  abnProof: "ABN_PROOF",
  bankProof: "BANK_PROOF",
};

const digits = (value) => String(value || "").replace(/\D/g, "");
const trimmed = (value) => String(value || "").trim();

/**
 * Maps the wizard's form state to the backend's CompleteOnboardingRequest, and nothing else. The
 * terms version is the one the partner was shown, so the backend can refuse it if the office has
 * published a newer one in the meantime.
 */
export const buildCompletePayload = (form, termsVersion) => ({
  fullName: trimmed(form.fullName),
  tradingName: trimmed(form.tradingName),
  phone: trimmed(form.phone),
  entityType: form.entityType,
  abn: digits(form.abn),
  tfn: digits(form.tfn),
  gstRegistered: form.gstRegistered === "yes" || form.gstRegistered === true,
  addressLine1: trimmed(form.addressLine1),
  addressLine2: trimmed(form.addressLine2),
  suburb: trimmed(form.suburb),
  state: trimmed(form.state),
  postcode: trimmed(form.postcode),
  country: trimmed(form.country) || "Australia",
  bankAccountName: trimmed(form.bankAccountName),
  bsb: digits(form.bsb),
  accountNumber: digits(form.accountNumber),
  password: form.password,
  acceptTerms: Boolean(form.acceptTerms),
  termsVersion,
});

/** A staff member already has a password, so their request is the same minus that. */
export const buildStaffCompletePayload = (form, termsVersion) => {
  const { password, ...rest } = buildCompletePayload(form, termsVersion);
  return rest;
};

export const fetchOnboardingPreview = async (token) => {
  const { data } = await axios.get(`${PUBLIC_BASE}/${token}`);
  return data;
};

export const uploadOnboardingDocument = async (token, kind, file) => {
  const body = new FormData();
  body.append("file", file);
  const { data } = await axios.post(`${PUBLIC_BASE}/${token}/documents?kind=${kind}`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const completeOnboarding = async (token, payload) =>
  axios.post(`${PUBLIC_BASE}/${token}/complete`, payload);
